<template>
    <div id="city-monitor" class="scrollbar">
        <a-spin :spinning="spinning">
            <div class="content" v-if="cityListDataSelect && !showDetails">
                <a-row
                        v-for="group in cityListDataSelect"
                        :key="group.menuId"
                >
                    <a-divider class="line" orientation="left">{{group.title}}</a-divider>
                    <a-col
                            class="item-grid"
                            v-for="(item,index) in group.children"
                            :key="index"
                            :xs="8"
                            :sm="8"
                            :xl="6"
                            :xxl="6"
                    >
                        <a-card hoverable style="width: 100%" @click="onClickDetails(item)">
                            <img
                                    v-if="item.menuCity"
                                    :src="item.menuCity | imgUrl(9)"
                                    slot="cover"
                                    class="item-img"
                            />
                            <img
                                    v-else
                                    :src="item.menuId | imgUrl(1)"
                                    slot="cover"
                                    class="item-img"
                            />
                            <a-card-meta :title="item.title">
                                <template
                                        slot="description"
                                >
                                    <!--{{item.subtitle ? item.subtitle : item.title}}-->
                                </template>
                            </a-card-meta>
                        </a-card>
                        <div class="shadow-box" v-if="item.enabled">
                            <div class="f16">
                                <span v-if="item.enabled === 1">暂无数据</span>
                                <span v-else-if="item.enabled === 2">登录可见</span>
                                <span v-else-if="item.enabled === 3">购买可见</span>
                                <span v-else>升级可见</span>
                            </div>
                        </div>
                    </a-col>
                </a-row>
            </div>
            <ResourceDetails
                    v-if="showDetails"
                    :detailsData="detailsData"
            />
        </a-spin>
    </div>
</template>

<script>
    import UrlApi from "@/utils/UrlApi.js";
    import ResourceDetails from "../ResourceDetails.vue";

    export default {
        name: "CityMonitor",
        data() {
            return {
                imgRootUrl: UrlApi.imgIconRoot,
                cityListDataSelect: null,
                spinning: false
            };
        },
        components: {
            ResourceDetails
        },
        computed: {
            showDetails() {
                let state = false;
                if (this.$route.query.detailsId) {
                    state = true;
                }
                return state;
            },
            // cityListDataSelect: {
            //     get() {
            //         let data = null
            //         this.cityListData.forEach(res => {
            //             if (res.menuId === this.id) {
            //                 let data = res
            //             }
            //         })
            //         return data
            //     }
            //     // return this.$store.getters.getCityListDataSelect;
            // },
            detailsData() {
                return this.$store.getters.getResourceDetailsData;
            },
            userName() {
                return this.$store.getters.getUserName;
            },
            id: {
                get() {
                    return this.$route.query.id
                }
            },
            seriousDate: {
                get() {
                    return this.$route.query.seriousDate
                }
            },
            startDate: {
                get() {
                    return this.$route.query.startDate
                }
            },
            endDate: {
                get() {
                    return this.$route.query.endDate
                }
            },
            DSTTagsList: {
                get() {
                    return this.$store.state.DSTTagsList
                },
                set(val) {
                    this.$store.commit("updateDSTTagsList", val);
                }
            },
        },
        mounted() {
            this.getData()
        },
        methods: {

            getData(id) {
                let url = UrlApi.cityList;
                let gpsState = this.$store.getters.getGpsState;
                let params = Object.assign({}, gpsState);
                params.userId = this.$store.getters.getUserId;
                let causeParams = Object.assign({}, params);
                causeParams.menuTypeId = id ? id : this.id;
                this.spinning = true

                // console.log(causeParams)

                // let p1 = new Promise((resolve) => {
                this.$http.get(url, {
                    params: causeParams
                }).then(res => {
                    this.spinning = false
                    // console.log(res)
                    this.cityListDataSelect = res.data.data
                })
                // })

            },

            onClickDetails(detailsData) {
                // console.log(detailsData)

                if (detailsData.children && detailsData.children.length) {
                    this.$router.push({
                        name: 'CityMonitor',
                        query: {id: detailsData.menuId}
                    })
                } else {

                    if(this.seriousDate){
                        this.$router.push({
                            name: 'ResourceDetails',
                            query: {
                                id: detailsData.menuId,
                                seriousDate:this.seriousDate,
                                startDate:this.startDate,
                                endDate:this.endDate,
                            }
                        })

                        return
                    }



                    let data = {
                        url: 'ResourceDetails',
                        name: detailsData.title,
                        query: JSON.stringify({id: detailsData.menuId})
                    }

                    this.handleVOCTagsList(data)
                    this.$router.push({
                        name: 'ResourceDetails',
                        query: {id: detailsData.menuId, synopsis: detailsData.synopsis, title: detailsData.title}
                    })
                }



                // let data = {
                //     url: 'ResourceDetails',
                //     name: detailsData.title,
                //     query: JSON.stringify({id: detailsData.menuId})
                // }
                //
                // this.handleVOCTagsList(data)
                //
                // this.$router.push({
                //     name: 'ResourceDetails',
                //     query: {id: detailsData.menuId, synopsis: detailsData.synopsis, title: detailsData.title}
                // })
                // this.$router.push({name: 'CityMonitor', query: {detailsId: detailsData.menuId}});
                // this.$store.commit("updateResourceDetailsData", {
                //     type: "CityMonitor",
                //     menuId: detailsData.menuId
                // });
            },
            handleVOCTagsList(item) {
                let List = JSON.parse(JSON.stringify(this.DSTTagsList))
                let isExist = false
                for (let i = 0; i < List.length; i++) {
                    if (List[i].url === item.url && List[i].query === item.query) {
                        isExist = true
                    }
                }

                if (!isExist) {
                    List.push(item)
                    this.DSTTagsList = List
                }
            },
        },
        beforeRouteUpdate(to, from, next) {
            this.getData(to.query.id)
            next();
        },
    }

</script>
<style lang="less" scoped>
    #city-monitor {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 106px);
        overflow: auto;
        .line {
            font-size: 22px;
            padding: 0 20px;
            &::before {
                border-top: 1px solid #2F639A;
            }
            &::after {
                border-top: 1px solid #2F639A;
            }
        }
    }

    .item-grid {
        padding: 0 20px;
        margin-top: 30px;
        padding-bottom: 10px;
        position: relative;
        top: 0;
        left: 0;
        .shadow-box {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            padding: 0 20px;
            padding-bottom: 10px;
            div {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(0, 0, 0, .4);
                color: #ffffff;
            }
        }
        .item-img {
            width: 100%;
            height: 200px;
        }
    }
</style>